
import { macroCondition, getGlobalConfig } from '@embroider/macros';


import defineModule0 from "./-embroider-implicit-modules.js";

import * as amdModule0 from "./initializers/ember-data-identifiers.js"
import * as amdModule1 from "./lib/booking-calendar.js"
import * as amdModule2 from "./lib/booking-filters.js"
import * as amdModule3 from "./lib/booking-people.js"
import * as amdModule4 from "./lib/booking-request.js"
import * as amdModule5 from "./lib/booking-steps.js"
import * as amdModule6 from "./lib/booking-validation.js"
import * as amdModule7 from "./resolver.js"
import * as amdModule8 from "./router.js"
import * as amdModule9 from "./serializers/application.js"
import * as amdModule10 from "./services/intl.js"
import * as amdModule11 from "./services/keyboard.js"
import * as amdModule12 from "./services/socket-io.js"
import * as amdModule13 from "./services/websockets.js"
import * as amdModule14 from "./services/-ensure-registered.js"
import * as amdModule15 from "./services/notify.js"
import * as amdModule16 from "./initializers/app-version.js"
import * as amdModule17 from "./instance-initializers/sentry-performance.js"
import * as amdModule18 from "./instance-initializers/load-translations.js"
import * as amdModule19 from "./services/power-calendar.js"
import * as amdModule20 from "./test-support/helpers.js"
import * as amdModule21 from "./initializers/ember-data.js"
import * as amdModule22 from "./services/store.js"
import * as amdModule23 from "./transforms/date.js"
import * as amdModule24 from "./transforms/number.js"
import * as amdModule25 from "./transforms/string.js"
import * as amdModule26 from "./transforms/boolean.js"
import * as amdModule27 from "./data-adapter.js"
import * as amdModule28 from "./services/quill.js"
import * as amdModule29 from "./adapters/application.js"
import * as amdModule30 from "./adapters/contact.js"
import * as amdModule31 from "./adapters/organization.js"
import * as amdModule32 from "./models/address.js"
import * as amdModule33 from "./models/application.js"
import * as amdModule34 from "./models/assurance.js"
import * as amdModule35 from "./models/category.js"
import * as amdModule36 from "./models/contact-consensi.js"
import * as amdModule37 from "./models/contact-parent.js"
import * as amdModule38 from "./models/contact-state.js"
import * as amdModule39 from "./models/contact.js"
import * as amdModule40 from "./models/custom-field-definition.js"
import * as amdModule41 from "./models/custom-field.js"
import * as amdModule42 from "./models/custom-reminder.js"
import * as amdModule43 from "./models/event-state.js"
import * as amdModule44 from "./models/event.js"
import * as amdModule45 from "./models/expense.js"
import * as amdModule46 from "./models/expensearticle.js"
import * as amdModule47 from "./models/expensepayment.js"
import * as amdModule48 from "./models/expire-date.js"
import * as amdModule49 from "./models/file.js"
import * as amdModule50 from "./models/invoice-style.js"
import * as amdModule51 from "./models/invoice.js"
import * as amdModule52 from "./models/invoicegroup.js"
import * as amdModule53 from "./models/invoicemailsend.js"
import * as amdModule54 from "./models/invoiceproduct-tax.js"
import * as amdModule55 from "./models/invoiceproduct.js"
import * as amdModule56 from "./models/invoices-notifiche-sdi.js"
import * as amdModule57 from "./models/invoicetax.js"
import * as amdModule58 from "./models/log.js"
import * as amdModule59 from "./models/notification.js"
import * as amdModule60 from "./models/organization-custom-field.js"
import * as amdModule61 from "./models/organization.js"
import * as amdModule62 from "./models/payment-method.js"
import * as amdModule63 from "./models/payment.js"
import * as amdModule64 from "./models/plan.js"
import * as amdModule65 from "./models/product-category.js"
import * as amdModule66 from "./models/product-state.js"
import * as amdModule67 from "./models/product.js"
import * as amdModule68 from "./models/project-consensi.js"
import * as amdModule69 from "./models/project-state.js"
import * as amdModule70 from "./models/project.js"
import * as amdModule71 from "./models/reminder-setting.js"
import * as amdModule72 from "./models/reminder.js"
import * as amdModule73 from "./models/role.js"
import * as amdModule74 from "./models/sub-category.js"
import * as amdModule75 from "./models/subscription.js"
import * as amdModule76 from "./models/tag.js"
import * as amdModule77 from "./models/todo.js"
import * as amdModule78 from "./models/todolist.js"
import * as amdModule79 from "./models/user-calendar.js"
import * as amdModule80 from "./models/user-invoice-setting.js"
import * as amdModule81 from "./models/user-reminder.js"
import * as amdModule82 from "./models/user-sezionale.js"
import * as amdModule83 from "./models/user-tax.js"
import * as amdModule84 from "./models/workhour-state.js"
import * as amdModule85 from "./models/workhour.js"
import * as amdModule86 from "./services/session.js"
import * as amdModule87 from "./core-app.js"
import * as amdModule88 from "./formats.js"
import * as amdModule89 from "./initializers/fontawesome.js"
import * as amdModule90 from "./initializers/offline-banner.js"
import * as amdModule91 from "./instance-initializers/dev-host.js"
import * as amdModule92 from "./services/app-state.js"
import * as amdModule93 from "./services/application.js"
import * as amdModule94 from "./services/beebee-base.js"
import * as amdModule95 from "./services/document-sign.js"
import * as amdModule96 from "./services/idle-screensaver.js"
import * as amdModule97 from "./services/index-context.js"
import * as amdModule98 from "./services/log.js"
import * as amdModule99 from "./services/modal-stack.js"
import * as amdModule100 from "./services/modal.js"
import * as amdModule101 from "./services/new-record-factory.js"
import * as amdModule102 from "./services/notification-message.js"
import * as amdModule103 from "./services/ringtone.js"
import * as amdModule104 from "./services/role-checker.js"
import * as amdModule105 from "./services/socket-sync.js"
import * as amdModule106 from "./services/socket-tracker.js"
import * as amdModule107 from "./services/third-party-boot.js"
import * as amdModule108 from "./services/window-viewport.js"
import * as amdModule109 from "./components/back-link.js"
import * as amdModule110 from "./components/bb-field.js"
import * as amdModule111 from "./components/booking-index/booking-summary.js"
import * as amdModule112 from "./components/booking-index/calendar-picker.js"
import * as amdModule113 from "./components/booking-index/contact-fields.js"
import * as amdModule114 from "./components/booking-index/people-fields.js"
import * as amdModule115 from "./components/booking-index/slot-picker.js"
import * as amdModule116 from "./components/booking-index/voucher-contact.js"
import * as amdModule117 from "./components/category-item.js"
import * as amdModule118 from "./components/category-list.js"
import * as amdModule119 from "./components/checkin-detail.js"
import * as amdModule120 from "./components/contact-button.js"
import * as amdModule121 from "./components/contact-item.js"
import * as amdModule122 from "./components/contact-list.js"
import * as amdModule123 from "./components/cookie-banner.js"
import * as amdModule124 from "./components/empty-category.js"
import * as amdModule125 from "./components/event-item.js"
import * as amdModule126 from "./components/event-people.js"
import * as amdModule127 from "./components/form-expired.js"
import * as amdModule128 from "./components/form-progress.js"
import * as amdModule129 from "./components/form-step-dati.js"
import * as amdModule130 from "./components/form-step-modulo.js"
import * as amdModule131 from "./components/form-step-project.js"
import * as amdModule132 from "./components/inline-login.js"
import * as amdModule133 from "./components/invoice-item.js"
import * as amdModule134 from "./components/lang-switch.js"
import * as amdModule135 from "./components/mobile-menu.js"
import * as amdModule136 from "./components/product-item.js"
import * as amdModule137 from "./components/product-list.js"
import * as amdModule138 from "./components/reschedule-modal.js"
import * as amdModule139 from "./components/voucher-item.js"
import * as amdModule140 from "./components/voucher-list-value.js"
import * as amdModule141 from "./components/voucher-list.js"
import * as amdModule142 from "./components/voucher-msg.js"
import * as amdModule143 from "./components/ember-popover.js"
import * as amdModule144 from "./components/ember-tooltip.js"
import * as amdModule145 from "./components/ember-notify.js"
import * as amdModule146 from "./components/ember-notify/message.js"
import * as amdModule147 from "./components/power-calendar-multiple.js"
import * as amdModule148 from "./components/power-calendar-multiple/days.js"
import * as amdModule149 from "./components/power-calendar-range.js"
import * as amdModule150 from "./components/power-calendar-range/days.js"
import * as amdModule151 from "./components/power-calendar.js"
import * as amdModule152 from "./components/power-calendar/days.js"
import * as amdModule153 from "./components/power-calendar/nav.js"
import * as amdModule154 from "./components/payment-method.js"
import * as amdModule155 from "./components/payment-method/payment-section.js"
import * as amdModule156 from "./components/bb-checkbox.js"
import * as amdModule157 from "./components/bb-chip-group.js"
import * as amdModule158 from "./components/bb-color-picker.js"
import * as amdModule159 from "./components/bb-date-range.js"
import * as amdModule160 from "./components/bb-editor.js"
import * as amdModule161 from "./components/bb-focus-input.js"
import * as amdModule162 from "./components/bb-input-currency.js"
import * as amdModule163 from "./components/bb-input-date.js"
import * as amdModule164 from "./components/bb-input-number.js"
import * as amdModule165 from "./components/bb-input-suggestion.js"
import * as amdModule166 from "./components/bb-input-tel.js"
import * as amdModule167 from "./components/bb-radio.js"
import * as amdModule168 from "./components/bb-range-slider.js"
import * as amdModule169 from "./components/bb-select.js"
import * as amdModule170 from "./components/bb-slider.js"
import * as amdModule171 from "./components/bb-textarea.js"
import * as amdModule172 from "./components/bb-toggle.js"
import * as amdModule173 from "./components/quill-editor.js"
import * as amdModule174 from "./components/quill.js"
import * as amdModule175 from "./components/quill/toolbar.js"
import * as amdModule176 from "./components/quill/toolbar/button-or-select.js"
import * as amdModule177 from "./components/quill/toolbar/button.js"
import * as amdModule178 from "./components/quill/toolbar/group.js"
import * as amdModule179 from "./components/quill/toolbar/select.js"
import * as amdModule180 from "./components/bb-custom-field-preview.js"
import * as amdModule181 from "./components/cf-advanced-textarea.js"
import * as amdModule182 from "./components/cf-table.js"
import * as amdModule183 from "./components/custom-field-value.js"
import * as amdModule184 from "./components/edit-custom-field.js"
import * as amdModule185 from "./components/view-custom-field.js"
import * as amdModule186 from "./components/bb-clock.js"
import * as amdModule187 from "./components/bb-time-ago.js"
import * as amdModule188 from "./components/belongs-to.js"
import * as amdModule189 from "./components/has-many.js"
import * as amdModule190 from "./components/related-contacts.js"
import * as amdModule191 from "./components/related-invoices.js"
import * as amdModule192 from "./components/select-association.js"
import * as amdModule193 from "./components/select-association/filter-bar.js"
import * as amdModule194 from "./components/select-association/result-list.js"
import * as amdModule195 from "./components/show-association.js"
import * as amdModule196 from "./components/addresses-list.js"
import * as amdModule197 from "./components/edit-single-address.js"
import * as amdModule198 from "./components/here-map.js"
import * as amdModule199 from "./components/related-addresses.js"
import * as amdModule200 from "./components/base-beebee-component.js"
import * as amdModule201 from "./components/base-edit-component.js"
import * as amdModule202 from "./components/bb-associate-button.js"
import * as amdModule203 from "./components/bb-birth-place-picker.js"
import * as amdModule204 from "./components/bb-chart.js"
import * as amdModule205 from "./components/bb-delete-button.js"
import * as amdModule206 from "./components/bb-dev-toolbar.js"
import * as amdModule207 from "./components/bb-draggable.js"
import * as amdModule208 from "./components/bb-dropdown.js"
import * as amdModule209 from "./components/bb-dropzone.js"
import * as amdModule210 from "./components/bb-email-history.js"
import * as amdModule211 from "./components/bb-expire-date.js"
import * as amdModule212 from "./components/bb-footer-mobile.js"
import * as amdModule213 from "./components/bb-has-many-paginator.js"
import * as amdModule214 from "./components/bb-help-widget.js"
import * as amdModule215 from "./components/bb-list-checkbox.js"
import * as amdModule216 from "./components/bb-list-filter.js"
import * as amdModule217 from "./components/bb-log-modal.js"
import * as amdModule218 from "./components/bb-mascot-loader.js"
import * as amdModule219 from "./components/bb-modal-modern.js"
import * as amdModule220 from "./components/bb-modal.js"
import * as amdModule221 from "./components/bb-paginator.js"
import * as amdModule222 from "./components/bb-panel.js"
import * as amdModule223 from "./components/bb-payment-form-modal.js"
import * as amdModule224 from "./components/bb-payments-list.js"
import * as amdModule225 from "./components/bb-pdf-viewer.js"
import * as amdModule226 from "./components/bb-presence-indicator.js"
import * as amdModule227 from "./components/bb-presence-list.js"
import * as amdModule228 from "./components/bb-reminder-board.js"
import * as amdModule229 from "./components/bb-save-menu.js"
import * as amdModule230 from "./components/bb-spinner.js"
import * as amdModule231 from "./components/bb-status-picker.js"
import * as amdModule232 from "./components/bb-tenant-palette.js"
import * as amdModule233 from "./components/bb-thumbnail.js"
import * as amdModule234 from "./components/bb-user-browser.js"
import * as amdModule235 from "./components/bb-user-platform.js"
import * as amdModule236 from "./components/power-select.js"
import * as amdModule237 from "./components/power-select/before-options.js"
import * as amdModule238 from "./components/power-select/input.js"
import * as amdModule239 from "./components/power-select/label.js"
import * as amdModule240 from "./components/power-select/no-matches-message.js"
import * as amdModule241 from "./components/power-select/options.js"
import * as amdModule242 from "./components/power-select/placeholder.js"
import * as amdModule243 from "./components/power-select/power-select-group.js"
import * as amdModule244 from "./components/power-select/search-message.js"
import * as amdModule245 from "./components/power-select/trigger.js"
import * as amdModule246 from "./components/basic-dropdown-content.js"
import * as amdModule247 from "./components/basic-dropdown-trigger.js"
import * as amdModule248 from "./components/basic-dropdown-wormhole.js"
import * as amdModule249 from "./components/basic-dropdown.js"
import * as amdModule250 from "./components/fa-icon.js"
import * as amdModule251 from "./helpers/format-date.js"
import * as amdModule252 from "./helpers/format-hour.js"
import * as amdModule253 from "./helpers/format-number.js"
import * as amdModule254 from "./helpers/t.js"
import * as amdModule255 from "./helpers/thumb-letter.js"
import * as amdModule256 from "./helpers/ensure-safe-component.js"
import * as amdModule257 from "./helpers/app-version.js"
import * as amdModule258 from "./helpers/pluralize.js"
import * as amdModule259 from "./helpers/singularize.js"
import * as amdModule260 from "./helpers/ember-power-calendar-day-classes.js"
import * as amdModule261 from "./helpers/power-calendar-format-date.js"
import * as amdModule262 from "./helpers/and.js"
import * as amdModule263 from "./helpers/eq.js"
import * as amdModule264 from "./helpers/gt.js"
import * as amdModule265 from "./helpers/gte.js"
import * as amdModule266 from "./helpers/is-array.js"
import * as amdModule267 from "./helpers/is-empty.js"
import * as amdModule268 from "./helpers/is-equal.js"
import * as amdModule269 from "./helpers/lt.js"
import * as amdModule270 from "./helpers/lte.js"
import * as amdModule271 from "./helpers/not-eq.js"
import * as amdModule272 from "./helpers/not.js"
import * as amdModule273 from "./helpers/or.js"
import * as amdModule274 from "./helpers/xor.js"
import * as amdModule275 from "./helpers/assign.js"
import * as amdModule276 from "./helpers/if-key.js"
import * as amdModule277 from "./helpers/on-key.js"
import * as amdModule278 from "./helpers/load.js"
import * as amdModule279 from "./helpers/brightness-by-color.js"
import * as amdModule280 from "./helpers/collection-contain.js"
import * as amdModule281 from "./helpers/collection-list.js"
import * as amdModule282 from "./helpers/component-exists.js"
import * as amdModule283 from "./helpers/concat-string.js"
import * as amdModule284 from "./helpers/css-style.js"
import * as amdModule285 from "./helpers/custom-field-icon.js"
import * as amdModule286 from "./helpers/date-diff-year.js"
import * as amdModule287 from "./helpers/date-diff.js"
import * as amdModule288 from "./helpers/date-ticks.js"
import * as amdModule289 from "./helpers/day-name.js"
import * as amdModule290 from "./helpers/def-currency.js"
import * as amdModule291 from "./helpers/first-object.js"
import * as amdModule292 from "./helpers/format-euro.js"
import * as amdModule293 from "./helpers/format-minute2string-day.js"
import * as amdModule294 from "./helpers/format-minute2string.js"
import * as amdModule295 from "./helpers/format-number2string.js"
import * as amdModule296 from "./helpers/generate-id.js"
import * as amdModule297 from "./helpers/human-custom-field-name.js"
import * as amdModule298 from "./helpers/icon-here.js"
import * as amdModule299 from "./helpers/in-array.js"
import * as amdModule300 from "./helpers/is-equal-large.js"
import * as amdModule301 from "./helpers/is-equal-not-empty.js"
import * as amdModule302 from "./helpers/is-gt.js"
import * as amdModule303 from "./helpers/is-image.js"
import * as amdModule304 from "./helpers/is-not.js"
import * as amdModule305 from "./helpers/is-pdf.js"
import * as amdModule306 from "./helpers/number-diff.js"
import * as amdModule307 from "./helpers/number-div.js"
import * as amdModule308 from "./helpers/number-mult.js"
import * as amdModule309 from "./helpers/number-sum.js"
import * as amdModule310 from "./helpers/number-to-hour.js"
import * as amdModule311 from "./helpers/read-path.js"
import * as amdModule312 from "./helpers/replace-br2comas.js"
import * as amdModule313 from "./helpers/safe-string.js"
import * as amdModule314 from "./helpers/set.js"
import * as amdModule315 from "./helpers/time-tickstotext.js"
import * as amdModule316 from "./helpers/todo-date-diff.js"
import * as amdModule317 from "./helpers/ember-power-select-is-array.js"
import * as amdModule318 from "./helpers/ember-power-select-is-equal.js"
import * as amdModule319 from "./helpers/ember-power-select-is-group.js"
import * as amdModule320 from "./helpers/ember-power-select-is-selected-present.js"
import * as amdModule321 from "./helpers/format-date-range.js"
import * as amdModule322 from "./helpers/format-display-name.js"
import * as amdModule323 from "./helpers/format-list.js"
import * as amdModule324 from "./helpers/format-message.js"
import * as amdModule325 from "./helpers/format-relative-time.js"
import * as amdModule326 from "./helpers/format-time.js"
import * as amdModule327 from "./helpers/t-key.js"
import * as amdModule328 from "./helpers/cancel-all.js"
import * as amdModule329 from "./helpers/perform.js"
import * as amdModule330 from "./helpers/task.js"
import * as amdModule331 from "./helpers/element.js"
import * as amdModule332 from "./modifiers/on-key.js"
import * as amdModule333 from "./modifiers/autofocus.js"
import * as amdModule334 from "./modifiers/dhtmlx-tooltip-guard.js"
import * as amdModule335 from "./modifiers/scroll-top-on-insert.js"
import * as amdModule336 from "./modifiers/basic-dropdown-trigger.js"
import * as amdModule337 from "./modifiers/style.js"
import * as amdModule338 from "./modifiers/did-insert.js"
import * as amdModule339 from "./modifiers/did-update.js"
import * as amdModule340 from "./modifiers/will-destroy.js"
import * as amdModule341 from "./templates/application.hbs"
import * as amdModule342 from "./controllers/application.js"
import * as amdModule343 from "./routes/application.js"
import * as amdModule344 from "./templates/checkin.hbs"
import * as amdModule345 from "./controllers/checkin.js"
import * as amdModule346 from "./routes/checkin.js"
import * as amdModule347 from "./templates/confirm.hbs"
import * as amdModule348 from "./controllers/confirm.js"
import * as amdModule349 from "./routes/confirm.js"
import * as amdModule350 from "./templates/form.hbs"
import * as amdModule351 from "./controllers/form.js"
import * as amdModule352 from "./routes/form.js"
import * as amdModule353 from "./templates/guide-personal-data.hbs"
import * as amdModule354 from "./controllers/guide-personal-data.js"
import * as amdModule355 from "./routes/guide-personal-data.js"
import * as amdModule356 from "./templates/heliguides-personal-data.hbs"
import * as amdModule357 from "./controllers/heliguides-personal-data.js"
import * as amdModule358 from "./routes/heliguides-personal-data.js"
import * as amdModule359 from "./templates/heliguides-sign-request.hbs"
import * as amdModule360 from "./controllers/heliguides-sign-request.js"
import * as amdModule361 from "./routes/heliguides-sign-request.js"
import * as amdModule362 from "./templates/index.hbs"
import * as amdModule363 from "./controllers/index.js"
import * as amdModule364 from "./routes/index.js"
import * as amdModule365 from "./templates/sciclub.hbs"
import * as amdModule366 from "./controllers/sciclub.js"
import * as amdModule367 from "./routes/sciclub.js"
import * as amdModule368 from "./templates/use-voucher.hbs"
import * as amdModule369 from "./controllers/use-voucher.js"
import * as amdModule370 from "./routes/use-voucher.js"
import * as amdModule371 from "./templates/user.hbs"
import * as amdModule372 from "./controllers/user.js"
import * as amdModule373 from "./routes/user.js"
import * as amdModule374 from "./templates/vouchers.hbs"
import * as amdModule375 from "./controllers/vouchers.js"
import * as amdModule376 from "./routes/vouchers.js"
import * as amdModule377 from "./routes/payment-status.js"
import * as amdModule378 from "./templates/error.hbs"
import * as amdModule379 from "./templates/loading.hbs"
import * as amdModule380 from "./routes/token-login.js"

let exportFastbootModules = {};





export default Object.assign(
  {},
defineModule0,
  {
"beebeeboard-booking/initializers/ember-data-identifiers": amdModule0,
"beebeeboard-booking/lib/booking-calendar": amdModule1,
"beebeeboard-booking/lib/booking-filters": amdModule2,
"beebeeboard-booking/lib/booking-people": amdModule3,
"beebeeboard-booking/lib/booking-request": amdModule4,
"beebeeboard-booking/lib/booking-steps": amdModule5,
"beebeeboard-booking/lib/booking-validation": amdModule6,
"beebeeboard-booking/resolver": amdModule7,
"beebeeboard-booking/router": amdModule8,
"beebeeboard-booking/serializers/application": amdModule9,
"beebeeboard-booking/services/intl": amdModule10,
"beebeeboard-booking/services/keyboard": amdModule11,
"beebeeboard-booking/services/socket-io": amdModule12,
"beebeeboard-booking/services/websockets": amdModule13,
"beebeeboard-booking/services/-ensure-registered": amdModule14,
"beebeeboard-booking/services/notify": amdModule15,
"beebeeboard-booking/initializers/app-version": amdModule16,
"beebeeboard-booking/instance-initializers/sentry-performance": amdModule17,
"beebeeboard-booking/instance-initializers/load-translations": amdModule18,
"beebeeboard-booking/services/power-calendar": amdModule19,
"beebeeboard-booking/test-support/helpers": amdModule20,
"beebeeboard-booking/initializers/ember-data": amdModule21,
"beebeeboard-booking/services/store": amdModule22,
"beebeeboard-booking/transforms/date": amdModule23,
"beebeeboard-booking/transforms/number": amdModule24,
"beebeeboard-booking/transforms/string": amdModule25,
"beebeeboard-booking/transforms/boolean": amdModule26,
"beebeeboard-booking/data-adapter": amdModule27,
"beebeeboard-booking/services/quill": amdModule28,
"beebeeboard-booking/adapters/application": amdModule29,
"beebeeboard-booking/adapters/contact": amdModule30,
"beebeeboard-booking/adapters/organization": amdModule31,
"beebeeboard-booking/models/address": amdModule32,
"beebeeboard-booking/models/application": amdModule33,
"beebeeboard-booking/models/assurance": amdModule34,
"beebeeboard-booking/models/category": amdModule35,
"beebeeboard-booking/models/contact-consensi": amdModule36,
"beebeeboard-booking/models/contact-parent": amdModule37,
"beebeeboard-booking/models/contact-state": amdModule38,
"beebeeboard-booking/models/contact": amdModule39,
"beebeeboard-booking/models/custom-field-definition": amdModule40,
"beebeeboard-booking/models/custom-field": amdModule41,
"beebeeboard-booking/models/custom-reminder": amdModule42,
"beebeeboard-booking/models/event-state": amdModule43,
"beebeeboard-booking/models/event": amdModule44,
"beebeeboard-booking/models/expense": amdModule45,
"beebeeboard-booking/models/expensearticle": amdModule46,
"beebeeboard-booking/models/expensepayment": amdModule47,
"beebeeboard-booking/models/expire-date": amdModule48,
"beebeeboard-booking/models/file": amdModule49,
"beebeeboard-booking/models/invoice-style": amdModule50,
"beebeeboard-booking/models/invoice": amdModule51,
"beebeeboard-booking/models/invoicegroup": amdModule52,
"beebeeboard-booking/models/invoicemailsend": amdModule53,
"beebeeboard-booking/models/invoiceproduct-tax": amdModule54,
"beebeeboard-booking/models/invoiceproduct": amdModule55,
"beebeeboard-booking/models/invoices-notifiche-sdi": amdModule56,
"beebeeboard-booking/models/invoicetax": amdModule57,
"beebeeboard-booking/models/log": amdModule58,
"beebeeboard-booking/models/notification": amdModule59,
"beebeeboard-booking/models/organization-custom-field": amdModule60,
"beebeeboard-booking/models/organization": amdModule61,
"beebeeboard-booking/models/payment-method": amdModule62,
"beebeeboard-booking/models/payment": amdModule63,
"beebeeboard-booking/models/plan": amdModule64,
"beebeeboard-booking/models/product-category": amdModule65,
"beebeeboard-booking/models/product-state": amdModule66,
"beebeeboard-booking/models/product": amdModule67,
"beebeeboard-booking/models/project-consensi": amdModule68,
"beebeeboard-booking/models/project-state": amdModule69,
"beebeeboard-booking/models/project": amdModule70,
"beebeeboard-booking/models/reminder-setting": amdModule71,
"beebeeboard-booking/models/reminder": amdModule72,
"beebeeboard-booking/models/role": amdModule73,
"beebeeboard-booking/models/sub-category": amdModule74,
"beebeeboard-booking/models/subscription": amdModule75,
"beebeeboard-booking/models/tag": amdModule76,
"beebeeboard-booking/models/todo": amdModule77,
"beebeeboard-booking/models/todolist": amdModule78,
"beebeeboard-booking/models/user-calendar": amdModule79,
"beebeeboard-booking/models/user-invoice-setting": amdModule80,
"beebeeboard-booking/models/user-reminder": amdModule81,
"beebeeboard-booking/models/user-sezionale": amdModule82,
"beebeeboard-booking/models/user-tax": amdModule83,
"beebeeboard-booking/models/workhour-state": amdModule84,
"beebeeboard-booking/models/workhour": amdModule85,
"beebeeboard-booking/services/session": amdModule86,
"beebeeboard-booking/core-app": amdModule87,
"beebeeboard-booking/formats": amdModule88,
"beebeeboard-booking/initializers/fontawesome": amdModule89,
"beebeeboard-booking/initializers/offline-banner": amdModule90,
"beebeeboard-booking/instance-initializers/dev-host": amdModule91,
"beebeeboard-booking/services/app-state": amdModule92,
"beebeeboard-booking/services/application": amdModule93,
"beebeeboard-booking/services/beebee-base": amdModule94,
"beebeeboard-booking/services/document-sign": amdModule95,
"beebeeboard-booking/services/idle-screensaver": amdModule96,
"beebeeboard-booking/services/index-context": amdModule97,
"beebeeboard-booking/services/log": amdModule98,
"beebeeboard-booking/services/modal-stack": amdModule99,
"beebeeboard-booking/services/modal": amdModule100,
"beebeeboard-booking/services/new-record-factory": amdModule101,
"beebeeboard-booking/services/notification-message": amdModule102,
"beebeeboard-booking/services/ringtone": amdModule103,
"beebeeboard-booking/services/role-checker": amdModule104,
"beebeeboard-booking/services/socket-sync": amdModule105,
"beebeeboard-booking/services/socket-tracker": amdModule106,
"beebeeboard-booking/services/third-party-boot": amdModule107,
"beebeeboard-booking/services/window-viewport": amdModule108,
"beebeeboard-booking/components/back-link": amdModule109,
"beebeeboard-booking/components/bb-field": amdModule110,
"beebeeboard-booking/components/booking-index/booking-summary": amdModule111,
"beebeeboard-booking/components/booking-index/calendar-picker": amdModule112,
"beebeeboard-booking/components/booking-index/contact-fields": amdModule113,
"beebeeboard-booking/components/booking-index/people-fields": amdModule114,
"beebeeboard-booking/components/booking-index/slot-picker": amdModule115,
"beebeeboard-booking/components/booking-index/voucher-contact": amdModule116,
"beebeeboard-booking/components/category-item": amdModule117,
"beebeeboard-booking/components/category-list": amdModule118,
"beebeeboard-booking/components/checkin-detail": amdModule119,
"beebeeboard-booking/components/contact-button": amdModule120,
"beebeeboard-booking/components/contact-item": amdModule121,
"beebeeboard-booking/components/contact-list": amdModule122,
"beebeeboard-booking/components/cookie-banner": amdModule123,
"beebeeboard-booking/components/empty-category": amdModule124,
"beebeeboard-booking/components/event-item": amdModule125,
"beebeeboard-booking/components/event-people": amdModule126,
"beebeeboard-booking/components/form-expired": amdModule127,
"beebeeboard-booking/components/form-progress": amdModule128,
"beebeeboard-booking/components/form-step-dati": amdModule129,
"beebeeboard-booking/components/form-step-modulo": amdModule130,
"beebeeboard-booking/components/form-step-project": amdModule131,
"beebeeboard-booking/components/inline-login": amdModule132,
"beebeeboard-booking/components/invoice-item": amdModule133,
"beebeeboard-booking/components/lang-switch": amdModule134,
"beebeeboard-booking/components/mobile-menu": amdModule135,
"beebeeboard-booking/components/product-item": amdModule136,
"beebeeboard-booking/components/product-list": amdModule137,
"beebeeboard-booking/components/reschedule-modal": amdModule138,
"beebeeboard-booking/components/voucher-item": amdModule139,
"beebeeboard-booking/components/voucher-list-value": amdModule140,
"beebeeboard-booking/components/voucher-list": amdModule141,
"beebeeboard-booking/components/voucher-msg": amdModule142,
"beebeeboard-booking/components/ember-popover": amdModule143,
"beebeeboard-booking/components/ember-tooltip": amdModule144,
"beebeeboard-booking/components/ember-notify": amdModule145,
"beebeeboard-booking/components/ember-notify/message": amdModule146,
"beebeeboard-booking/components/power-calendar-multiple": amdModule147,
"beebeeboard-booking/components/power-calendar-multiple/days": amdModule148,
"beebeeboard-booking/components/power-calendar-range": amdModule149,
"beebeeboard-booking/components/power-calendar-range/days": amdModule150,
"beebeeboard-booking/components/power-calendar": amdModule151,
"beebeeboard-booking/components/power-calendar/days": amdModule152,
"beebeeboard-booking/components/power-calendar/nav": amdModule153,
"beebeeboard-booking/components/payment-method": amdModule154,
"beebeeboard-booking/components/payment-method/payment-section": amdModule155,
"beebeeboard-booking/components/bb-checkbox": amdModule156,
"beebeeboard-booking/components/bb-chip-group": amdModule157,
"beebeeboard-booking/components/bb-color-picker": amdModule158,
"beebeeboard-booking/components/bb-date-range": amdModule159,
"beebeeboard-booking/components/bb-editor": amdModule160,
"beebeeboard-booking/components/bb-focus-input": amdModule161,
"beebeeboard-booking/components/bb-input-currency": amdModule162,
"beebeeboard-booking/components/bb-input-date": amdModule163,
"beebeeboard-booking/components/bb-input-number": amdModule164,
"beebeeboard-booking/components/bb-input-suggestion": amdModule165,
"beebeeboard-booking/components/bb-input-tel": amdModule166,
"beebeeboard-booking/components/bb-radio": amdModule167,
"beebeeboard-booking/components/bb-range-slider": amdModule168,
"beebeeboard-booking/components/bb-select": amdModule169,
"beebeeboard-booking/components/bb-slider": amdModule170,
"beebeeboard-booking/components/bb-textarea": amdModule171,
"beebeeboard-booking/components/bb-toggle": amdModule172,
"beebeeboard-booking/components/quill-editor": amdModule173,
"beebeeboard-booking/components/quill": amdModule174,
"beebeeboard-booking/components/quill/toolbar": amdModule175,
"beebeeboard-booking/components/quill/toolbar/button-or-select": amdModule176,
"beebeeboard-booking/components/quill/toolbar/button": amdModule177,
"beebeeboard-booking/components/quill/toolbar/group": amdModule178,
"beebeeboard-booking/components/quill/toolbar/select": amdModule179,
"beebeeboard-booking/components/bb-custom-field-preview": amdModule180,
"beebeeboard-booking/components/cf-advanced-textarea": amdModule181,
"beebeeboard-booking/components/cf-table": amdModule182,
"beebeeboard-booking/components/custom-field-value": amdModule183,
"beebeeboard-booking/components/edit-custom-field": amdModule184,
"beebeeboard-booking/components/view-custom-field": amdModule185,
"beebeeboard-booking/components/bb-clock": amdModule186,
"beebeeboard-booking/components/bb-time-ago": amdModule187,
"beebeeboard-booking/components/belongs-to": amdModule188,
"beebeeboard-booking/components/has-many": amdModule189,
"beebeeboard-booking/components/related-contacts": amdModule190,
"beebeeboard-booking/components/related-invoices": amdModule191,
"beebeeboard-booking/components/select-association": amdModule192,
"beebeeboard-booking/components/select-association/filter-bar": amdModule193,
"beebeeboard-booking/components/select-association/result-list": amdModule194,
"beebeeboard-booking/components/show-association": amdModule195,
"beebeeboard-booking/components/addresses-list": amdModule196,
"beebeeboard-booking/components/edit-single-address": amdModule197,
"beebeeboard-booking/components/here-map": amdModule198,
"beebeeboard-booking/components/related-addresses": amdModule199,
"beebeeboard-booking/components/base-beebee-component": amdModule200,
"beebeeboard-booking/components/base-edit-component": amdModule201,
"beebeeboard-booking/components/bb-associate-button": amdModule202,
"beebeeboard-booking/components/bb-birth-place-picker": amdModule203,
"beebeeboard-booking/components/bb-chart": amdModule204,
"beebeeboard-booking/components/bb-delete-button": amdModule205,
"beebeeboard-booking/components/bb-dev-toolbar": amdModule206,
"beebeeboard-booking/components/bb-draggable": amdModule207,
"beebeeboard-booking/components/bb-dropdown": amdModule208,
"beebeeboard-booking/components/bb-dropzone": amdModule209,
"beebeeboard-booking/components/bb-email-history": amdModule210,
"beebeeboard-booking/components/bb-expire-date": amdModule211,
"beebeeboard-booking/components/bb-footer-mobile": amdModule212,
"beebeeboard-booking/components/bb-has-many-paginator": amdModule213,
"beebeeboard-booking/components/bb-help-widget": amdModule214,
"beebeeboard-booking/components/bb-list-checkbox": amdModule215,
"beebeeboard-booking/components/bb-list-filter": amdModule216,
"beebeeboard-booking/components/bb-log-modal": amdModule217,
"beebeeboard-booking/components/bb-mascot-loader": amdModule218,
"beebeeboard-booking/components/bb-modal-modern": amdModule219,
"beebeeboard-booking/components/bb-modal": amdModule220,
"beebeeboard-booking/components/bb-paginator": amdModule221,
"beebeeboard-booking/components/bb-panel": amdModule222,
"beebeeboard-booking/components/bb-payment-form-modal": amdModule223,
"beebeeboard-booking/components/bb-payments-list": amdModule224,
"beebeeboard-booking/components/bb-pdf-viewer": amdModule225,
"beebeeboard-booking/components/bb-presence-indicator": amdModule226,
"beebeeboard-booking/components/bb-presence-list": amdModule227,
"beebeeboard-booking/components/bb-reminder-board": amdModule228,
"beebeeboard-booking/components/bb-save-menu": amdModule229,
"beebeeboard-booking/components/bb-spinner": amdModule230,
"beebeeboard-booking/components/bb-status-picker": amdModule231,
"beebeeboard-booking/components/bb-tenant-palette": amdModule232,
"beebeeboard-booking/components/bb-thumbnail": amdModule233,
"beebeeboard-booking/components/bb-user-browser": amdModule234,
"beebeeboard-booking/components/bb-user-platform": amdModule235,
"beebeeboard-booking/components/power-select": amdModule236,
"beebeeboard-booking/components/power-select/before-options": amdModule237,
"beebeeboard-booking/components/power-select/input": amdModule238,
"beebeeboard-booking/components/power-select/label": amdModule239,
"beebeeboard-booking/components/power-select/no-matches-message": amdModule240,
"beebeeboard-booking/components/power-select/options": amdModule241,
"beebeeboard-booking/components/power-select/placeholder": amdModule242,
"beebeeboard-booking/components/power-select/power-select-group": amdModule243,
"beebeeboard-booking/components/power-select/search-message": amdModule244,
"beebeeboard-booking/components/power-select/trigger": amdModule245,
"beebeeboard-booking/components/basic-dropdown-content": amdModule246,
"beebeeboard-booking/components/basic-dropdown-trigger": amdModule247,
"beebeeboard-booking/components/basic-dropdown-wormhole": amdModule248,
"beebeeboard-booking/components/basic-dropdown": amdModule249,
"beebeeboard-booking/components/fa-icon": amdModule250,
"beebeeboard-booking/helpers/format-date": amdModule251,
"beebeeboard-booking/helpers/format-hour": amdModule252,
"beebeeboard-booking/helpers/format-number": amdModule253,
"beebeeboard-booking/helpers/t": amdModule254,
"beebeeboard-booking/helpers/thumb-letter": amdModule255,
"beebeeboard-booking/helpers/ensure-safe-component": amdModule256,
"beebeeboard-booking/helpers/app-version": amdModule257,
"beebeeboard-booking/helpers/pluralize": amdModule258,
"beebeeboard-booking/helpers/singularize": amdModule259,
"beebeeboard-booking/helpers/ember-power-calendar-day-classes": amdModule260,
"beebeeboard-booking/helpers/power-calendar-format-date": amdModule261,
"beebeeboard-booking/helpers/and": amdModule262,
"beebeeboard-booking/helpers/eq": amdModule263,
"beebeeboard-booking/helpers/gt": amdModule264,
"beebeeboard-booking/helpers/gte": amdModule265,
"beebeeboard-booking/helpers/is-array": amdModule266,
"beebeeboard-booking/helpers/is-empty": amdModule267,
"beebeeboard-booking/helpers/is-equal": amdModule268,
"beebeeboard-booking/helpers/lt": amdModule269,
"beebeeboard-booking/helpers/lte": amdModule270,
"beebeeboard-booking/helpers/not-eq": amdModule271,
"beebeeboard-booking/helpers/not": amdModule272,
"beebeeboard-booking/helpers/or": amdModule273,
"beebeeboard-booking/helpers/xor": amdModule274,
"beebeeboard-booking/helpers/assign": amdModule275,
"beebeeboard-booking/helpers/if-key": amdModule276,
"beebeeboard-booking/helpers/on-key": amdModule277,
"beebeeboard-booking/helpers/load": amdModule278,
"beebeeboard-booking/helpers/brightness-by-color": amdModule279,
"beebeeboard-booking/helpers/collection-contain": amdModule280,
"beebeeboard-booking/helpers/collection-list": amdModule281,
"beebeeboard-booking/helpers/component-exists": amdModule282,
"beebeeboard-booking/helpers/concat-string": amdModule283,
"beebeeboard-booking/helpers/css-style": amdModule284,
"beebeeboard-booking/helpers/custom-field-icon": amdModule285,
"beebeeboard-booking/helpers/date-diff-year": amdModule286,
"beebeeboard-booking/helpers/date-diff": amdModule287,
"beebeeboard-booking/helpers/date-ticks": amdModule288,
"beebeeboard-booking/helpers/day-name": amdModule289,
"beebeeboard-booking/helpers/def-currency": amdModule290,
"beebeeboard-booking/helpers/first-object": amdModule291,
"beebeeboard-booking/helpers/format-euro": amdModule292,
"beebeeboard-booking/helpers/format-minute2string-day": amdModule293,
"beebeeboard-booking/helpers/format-minute2string": amdModule294,
"beebeeboard-booking/helpers/format-number2string": amdModule295,
"beebeeboard-booking/helpers/generate-id": amdModule296,
"beebeeboard-booking/helpers/human-custom-field-name": amdModule297,
"beebeeboard-booking/helpers/icon-here": amdModule298,
"beebeeboard-booking/helpers/in-array": amdModule299,
"beebeeboard-booking/helpers/is-equal-large": amdModule300,
"beebeeboard-booking/helpers/is-equal-not-empty": amdModule301,
"beebeeboard-booking/helpers/is-gt": amdModule302,
"beebeeboard-booking/helpers/is-image": amdModule303,
"beebeeboard-booking/helpers/is-not": amdModule304,
"beebeeboard-booking/helpers/is-pdf": amdModule305,
"beebeeboard-booking/helpers/number-diff": amdModule306,
"beebeeboard-booking/helpers/number-div": amdModule307,
"beebeeboard-booking/helpers/number-mult": amdModule308,
"beebeeboard-booking/helpers/number-sum": amdModule309,
"beebeeboard-booking/helpers/number-to-hour": amdModule310,
"beebeeboard-booking/helpers/read-path": amdModule311,
"beebeeboard-booking/helpers/replace-br2comas": amdModule312,
"beebeeboard-booking/helpers/safe-string": amdModule313,
"beebeeboard-booking/helpers/set": amdModule314,
"beebeeboard-booking/helpers/time-tickstotext": amdModule315,
"beebeeboard-booking/helpers/todo-date-diff": amdModule316,
"beebeeboard-booking/helpers/ember-power-select-is-array": amdModule317,
"beebeeboard-booking/helpers/ember-power-select-is-equal": amdModule318,
"beebeeboard-booking/helpers/ember-power-select-is-group": amdModule319,
"beebeeboard-booking/helpers/ember-power-select-is-selected-present": amdModule320,
"beebeeboard-booking/helpers/format-date-range": amdModule321,
"beebeeboard-booking/helpers/format-display-name": amdModule322,
"beebeeboard-booking/helpers/format-list": amdModule323,
"beebeeboard-booking/helpers/format-message": amdModule324,
"beebeeboard-booking/helpers/format-relative-time": amdModule325,
"beebeeboard-booking/helpers/format-time": amdModule326,
"beebeeboard-booking/helpers/t-key": amdModule327,
"beebeeboard-booking/helpers/cancel-all": amdModule328,
"beebeeboard-booking/helpers/perform": amdModule329,
"beebeeboard-booking/helpers/task": amdModule330,
"beebeeboard-booking/helpers/element": amdModule331,
"beebeeboard-booking/modifiers/on-key": amdModule332,
"beebeeboard-booking/modifiers/autofocus": amdModule333,
"beebeeboard-booking/modifiers/dhtmlx-tooltip-guard": amdModule334,
"beebeeboard-booking/modifiers/scroll-top-on-insert": amdModule335,
"beebeeboard-booking/modifiers/basic-dropdown-trigger": amdModule336,
"beebeeboard-booking/modifiers/style": amdModule337,
"beebeeboard-booking/modifiers/did-insert": amdModule338,
"beebeeboard-booking/modifiers/did-update": amdModule339,
"beebeeboard-booking/modifiers/will-destroy": amdModule340,
"beebeeboard-booking/templates/application": amdModule341,
"beebeeboard-booking/controllers/application": amdModule342,
"beebeeboard-booking/routes/application": amdModule343,
"beebeeboard-booking/templates/checkin": amdModule344,
"beebeeboard-booking/controllers/checkin": amdModule345,
"beebeeboard-booking/routes/checkin": amdModule346,
"beebeeboard-booking/templates/confirm": amdModule347,
"beebeeboard-booking/controllers/confirm": amdModule348,
"beebeeboard-booking/routes/confirm": amdModule349,
"beebeeboard-booking/templates/form": amdModule350,
"beebeeboard-booking/controllers/form": amdModule351,
"beebeeboard-booking/routes/form": amdModule352,
"beebeeboard-booking/templates/guide-personal-data": amdModule353,
"beebeeboard-booking/controllers/guide-personal-data": amdModule354,
"beebeeboard-booking/routes/guide-personal-data": amdModule355,
"beebeeboard-booking/templates/heliguides-personal-data": amdModule356,
"beebeeboard-booking/controllers/heliguides-personal-data": amdModule357,
"beebeeboard-booking/routes/heliguides-personal-data": amdModule358,
"beebeeboard-booking/templates/heliguides-sign-request": amdModule359,
"beebeeboard-booking/controllers/heliguides-sign-request": amdModule360,
"beebeeboard-booking/routes/heliguides-sign-request": amdModule361,
"beebeeboard-booking/templates/index": amdModule362,
"beebeeboard-booking/controllers/index": amdModule363,
"beebeeboard-booking/routes/index": amdModule364,
"beebeeboard-booking/templates/sciclub": amdModule365,
"beebeeboard-booking/controllers/sciclub": amdModule366,
"beebeeboard-booking/routes/sciclub": amdModule367,
"beebeeboard-booking/templates/use-voucher": amdModule368,
"beebeeboard-booking/controllers/use-voucher": amdModule369,
"beebeeboard-booking/routes/use-voucher": amdModule370,
"beebeeboard-booking/templates/user": amdModule371,
"beebeeboard-booking/controllers/user": amdModule372,
"beebeeboard-booking/routes/user": amdModule373,
"beebeeboard-booking/templates/vouchers": amdModule374,
"beebeeboard-booking/controllers/vouchers": amdModule375,
"beebeeboard-booking/routes/vouchers": amdModule376,
"beebeeboard-booking/routes/payment-status": amdModule377,
"beebeeboard-booking/templates/error": amdModule378,
"beebeeboard-booking/templates/loading": amdModule379,
"beebeeboard-booking/routes/token-login": amdModule380,
  },
  exportFastbootModules
);
